export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    const lenis = window.__lenis;
    if (lenis) lenis.scrollTo(el, { offset: -84, duration: 1.1 });
    else el.scrollIntoView({ behavior: "smooth" });
};
